import { useEffect, useRef } from "react";

interface ResizeObserverParams {
    onResize?: (entries: ResizeObserverEntry[]) => void;
}

export const useResizeObserver = ({ onResize }: ResizeObserverParams) => {
    const resizeObserver = useRef<ResizeObserver>(
        new ResizeObserver(entries => {
            requestAnimationFrame(() => {
                onResize?.(entries);
            });
        })
    );

    useEffect(
        () => () => {
            resizeObserver.current.disconnect();
        },
        []
    );

    return resizeObserver.current;
};
